import { render, staticRenderFns } from "./marketFormLandPage.vue?vue&type=template&id=4ecb37bb&scoped=true&"
import script from "./marketFormLandPage.vue?vue&type=script&lang=js&"
export * from "./marketFormLandPage.vue?vue&type=script&lang=js&"
import style0 from "./marketFormLandPage.vue?vue&type=style&index=0&id=4ecb37bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb37bb",
  null
  
)

export default component.exports